import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { PdfModalComponent } from './pdf-modal.component';

@Injectable()
export class PdfModalService {


  constructor(private dialog: MatDialog, private platform: Platform) { }

  openModal(pdf): Observable<string> {
    let dialogRef: MatDialogRef<PdfModalComponent>;

    let options;
    
    if (this.platform.ANDROID || this.platform.IOS) {
      options = {
        width: "100vw",
        maxWidth: "100vw",
        height: "90vh"
      }
    }
    dialogRef = this.dialog.open(PdfModalComponent, {disableClose: false, ...options });
    dialogRef.componentInstance.imagen = null;
    dialogRef.componentInstance.pdf = pdf;
    return dialogRef.afterClosed();
  }
  // showImage(imagen): Observable<string> {
  //   let dialogRef: MatDialogRef<PdfModalComponent>;
  //   dialogRef = this.dialog.open(PdfModalComponent, {disableClose: false });   
  //   dialogRef.componentInstance.imagen = imagen;
  //   return dialogRef.afterClosed();

  // }
}



// WEBPACK FOOTER //
// ./src/app/core/pdf-modal/pdf-modal.service.ts